import { z } from "zod";

export const emailSchema = z.string().email("Invalid email format");

export type Email = z.infer<typeof emailSchema>;

export function isValidEmail(value: string): value is Email {
  return emailSchema.safeParse(value).success;
}
